module.exports = __webpack_public_path__ + "media/images/design/images/bn_cm-ba6f93c80f8191f49e28edaf6ad2ffeb.jpg";